export const DialogTestIds = {
  dialogSubmessage: 'dialog_submessage',
  dialogInputField: 'dialog_input_field',
  copyBtn: 'dialog_copy_btn'
} as const;
